import React, { useState, useContext, useEffect } from 'react'
import styles from './address-details.module.scss'
import Button from 'src/components//button/Button'
import { StateContext } from '../../AppContext'
import { IState, IAddress } from 'src/Interface'
import axios from 'axios'
import { baseApiURL } from 'src/utils/utils'
import AutocompletePoi from 'src/components/autocomplete/AutocompletePoi'
import { toast } from 'react-toastify'
import { DispatchContext } from 'src/AppContext'
import Input from 'src/components//input/Input'
import { validString } from 'src/utils/utils'

interface IError {
  label: boolean
}
interface IProps {
  close?: any
  branchId: number
  addressId: number
  companyId: number
}


const AddressesPOIDetails: React.FunctionComponent<IProps> = ({ close, addressId, branchId }: IProps) => {
  const state: IState = useContext(StateContext)
  const [address, setAddress] =  useState<IAddress>(null)
  const dispatch = useContext(DispatchContext)

  const currentAddress = state.customAddresses.find(address => address.id === Number(addressId))
  const [errors, setErrors] = useState<IError>({
    label: false,
  })

  const [validationErrors, setValidationErrors] = useState<IError>({
    label: false,
  })
  
  const resetError = (fieldName: string) => {
    setErrors({
      ...errors,
      [fieldName]: false
    })
    setValidationErrors({
      ...validationErrors,
      [fieldName]: false
    })
  }

  const handleValidation = (regexp: RegExp, fieldName: string) => (value: string) => {
    let error = false
    if (value && regexp && !regexp.test(value || '')) {
      error = true
    }

    setValidationErrors({
      ...validationErrors,
      [fieldName]: error
    })
  }
  const handleInputChange = (fieldName: string) => (value: any) => {
    if(fieldName==='address'){
      setAddress(value)
    }
    else if(fieldName==='label'){
      setAddress({...address, label:value})
    }
  }

  useEffect(() => {
    setAddress(currentAddress)
  }, [currentAddress])

  const updateAddress = () => {
    if (state.user.accessToken) {
      axios.put(`${baseApiURL()}/branches/${branchId}/custom_addresses/${addressId}`,
      address, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
        .then(() => {
          return null
        }).then(() => {
          return axios(`${baseApiURL()}/branches/${branchId}/custom_addresses`, {
            headers: {
              Authorization:
                `Bearer ${state.user.accessToken}`
            }
          })
        }).then((result: any) => {
          dispatch({ type: 'SET_CUSTOM_ADDRESSES', addresses: result.data })
          close()
        }).catch((err: any) => {
          toast(err.response.data.message)
        })
    }
  }

  const deleteAddress = () => {
    if (state.user.accessToken) {
      axios.delete(`${baseApiURL()}/branches/${branchId}/custom_addresses/${addressId}`,
        {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        }).then(() => {
          return null
        }).then(() => {
          return axios(`${baseApiURL()}/branches/${branchId}/custom_addresses`, {
            headers: {
              Authorization:
                `Bearer ${state.user.accessToken}`
            }
          })
        }).then((result: any) => {
          dispatch({ type: 'SET_CUSTOM_ADDRESSES', addresses: result.data })
          close()
        }).catch((err: any) => {
          toast(err.response.data.message)
        })
    }
  }
 
  return (
    <>
      <header className={styles.header}>
        <h3>{`Brugerdefinerede adresser`}</h3>
        <span className={styles.closeIcon} onClick={close}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </span>
      </header>
      <div className={styles.container}>
        <div className={styles.userInfo}>
          <h4 className={styles.subTitle}>Detaljer</h4>
          <AutocompletePoi modifiers='tw-mb-3' name='address' setAddress={() => setAddress} completedAddress={currentAddress} />
          <div className='tw-mb-3'>
          <Input
              label='Label *'
              type='text'
              value={address?.label}
              error={errors.label || validationErrors.label}
              resetError={() => resetError('label')}
              handleValidation={() => handleValidation(validString, 'label')}
              handleInputChange={() => handleInputChange('label')}
              name='label'
              placeholder='Label'
            />
            {validationErrors.label && <p className='errorMsg'>bør kun bestå af tal og være mellem 1 og 6 karakterer.</p>}
            {errors.label && <p className='errorMsg'>Konto koden eksisterer allerede</p>}
          </div>
          <div className='tw-mb-3'>
            <Input
              readOnly
              label='POI'
              type='text'
              value={address?.poi}
              name='poi'
              placeholder='POI'
            />
          </div>

          <div className='tw-mb-3'>
            <Input
              readOnly
              label='Husnummer'
              type='text'
              value={address?.houseNo}
              name='houseNo'
              placeholder='Husnummer'
            />
          </div>

          <div className='tw-mb-3'>
            <Input
              readOnly
              label='Postnummer'
              type='text'
              value={address?.zipCode}
              name='zipCode'
              placeholder='Postnummer'
            />
          </div>

          <div className='tw-mb-3'>
            <Input
              readOnly
              label='Vejnavn'
              type='text'
              value={address?.streetName}
              name='streetName'
              placeholder='Vejnavn'
            />
        </div>
        </div>
      </div>
      <footer className={styles.footer}>
        <Button modifiers='tw-ml-auto' type='destructive' label='Fjern' handleClick={deleteAddress} />
        <Button disabled={!(address?.label)} modifiers='tw-ml-3' type='primary' label='Gem ændringer' handleClick={updateAddress} />
      </footer>
    </>
  )
}

export default AddressesPOIDetails
